import React, { useEffect, useState } from 'react';
import { Button, message, Modal } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { CopyOutlined } from '@ant-design/icons';
import { myStringSorter } from '../../../../extras/sorters';

interface Props {
  open : boolean;
  codeList: string[];
  handleSetModalOpened: (opened: boolean) => void;
}
export const ModalShowCode = (props: Props) => {

  const [codeList, setCodeList] = useState('');
  const [messageApi, contextHolder] = message.useMessage();
  const handleOk = async () => {
    props.handleSetModalOpened(false);
  }

  const handleCancel = async () => {
    props.handleSetModalOpened(false);
  }

  useEffect(() => {
    setCodeList(Array.from(new Set(props.codeList)).sort((a, b) => myStringSorter(a,b)).map(code => String(code)).join('\n'));
  },[props.codeList]);


  const copyToClip = () => {
    navigator.clipboard.writeText(codeList);


    messageApi.open({
      type: 'success',
      content: 'Skopiowano do schowka!',
    });

  }

  return <Modal destroyOnClose={true}  bodyStyle={{padding: 10,}} title={`Lista UDC (${props.codeList.length})`} open={props.open} onCancel={handleCancel} onOk={handleOk}>
    <>
      <Button type={'text'} onClick={() => copyToClip()} icon={<CopyOutlined />}></Button>
      <div style={{ display: 'flex', alignItems: 'center', alignContent: 'flex-end', justifyContent: 'space-evenly', padding: 5 }}>
        <TextArea rows={15} size={'small'} value={codeList} />
      </div>

      {contextHolder}
    </>
  </Modal>
}
